// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet aanvragen-public API
 * OpenAPI spec version: 1
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, toValue, unref } from 'vue';
import type { MaybeRefOrGetter } from 'vue';

import type { CollectionResultOfAanvragenMaatwerkGetPremiedetailsBijMaatschappijenVoorMaatwerkMaatschappijenPremiedetailsDto } from '../model/collectionResultOfAanvragenMaatwerkGetPremiedetailsBijMaatschappijenVoorMaatwerkMaatschappijenPremiedetailsDto.ts';

import type { CollectionResultOfDocumentenDocumentenGetMaatwerkDocumentenDto } from '../model/collectionResultOfDocumentenDocumentenGetMaatwerkDocumentenDto.ts';

import type { CollectionResultOfProductenMaatschappijenGetSelecteerbareProductmaatschappijenVoorProductDto } from '../model/collectionResultOfProductenMaatschappijenGetSelecteerbareProductmaatschappijenVoorProductDto.ts';

import type { MaatwerkdossierCreateMaatwerkDossierParams } from '../model/maatwerkdossierCreateMaatwerkDossierParams.ts';

import type { MaatwerkdossierDocumentUploadenBody } from '../model/maatwerkdossierDocumentUploadenBody.ts';

import type { MaatwerkdossierGetMaatwerkDossierParams } from '../model/maatwerkdossierGetMaatwerkDossierParams.ts';

import type { MaatwerkdossierKoppelAntwoordensetParams } from '../model/maatwerkdossierKoppelAntwoordensetParams.ts';

import type { MicrosoftAspNetCoreHttpHttpValidationProblemDetails } from '../model/microsoftAspNetCoreHttpHttpValidationProblemDetails.ts';

import type { MicrosoftAspNetCoreMvcProblemDetails } from '../model/microsoftAspNetCoreMvcProblemDetails.ts';

import type { Result1OfAanvragenMaatwerkGetMaatwerkdossierDetailsDto } from '../model/result1OfAanvragenMaatwerkGetMaatwerkdossierDetailsDto.ts';

import type { Result1OfAanvragenMaatwerkGetMaatwerkdossierDto } from '../model/result1OfAanvragenMaatwerkGetMaatwerkdossierDto.ts';

import type { Result1OfAanvragenMaatwerkGetWagenparkSpecificatiesVoorOfferteformulierDto } from '../model/result1OfAanvragenMaatwerkGetWagenparkSpecificatiesVoorOfferteformulierDto.ts';

import type { Result1OfSUREbusinessCommonDomainTypedIdsMaatwerkdossierId } from '../model/result1OfSUREbusinessCommonDomainTypedIdsMaatwerkdossierId.ts';

import { customInstance } from '../../customInstance.ts';
import type { ErrorType } from '../../customInstance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Maatwerk.Inzien</li></ul>
 * @summary Haalt een maatwerkdossier op voor het opgegeven offerteproduct.
 */
export const maatwerkdossierGetMaatwerkDossier = (
  params?: MaybeRefOrGetter<MaatwerkdossierGetMaatwerkDossierParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = toValue(params);

  return customInstance<Result1OfAanvragenMaatwerkGetMaatwerkdossierDto>(
    { url: `/api/v1/maatwerk`, method: 'GET', params, signal },
    options,
  );
};

export const getMaatwerkdossierGetMaatwerkDossierQueryKey = (
  params?: MaybeRefOrGetter<MaatwerkdossierGetMaatwerkDossierParams>,
) => {
  return ['api', 'v1', 'maatwerk', ...(params ? [params] : [])] as const;
};

export const getMaatwerkdossierGetMaatwerkDossierQueryOptions = <
  TData = Awaited<ReturnType<typeof maatwerkdossierGetMaatwerkDossier>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<MaatwerkdossierGetMaatwerkDossierParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof maatwerkdossierGetMaatwerkDossier>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getMaatwerkdossierGetMaatwerkDossierQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof maatwerkdossierGetMaatwerkDossier>>> = ({
    signal,
  }) => maatwerkdossierGetMaatwerkDossier(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof maatwerkdossierGetMaatwerkDossier>>,
    TError,
    TData
  >;
};

export type MaatwerkdossierGetMaatwerkDossierQueryResult = NonNullable<
  Awaited<ReturnType<typeof maatwerkdossierGetMaatwerkDossier>>
>;
export type MaatwerkdossierGetMaatwerkDossierQueryError = ErrorType<void>;

/**
 * @summary Haalt een maatwerkdossier op voor het opgegeven offerteproduct.
 */

export function useMaatwerkdossierGetMaatwerkDossier<
  TData = Awaited<ReturnType<typeof maatwerkdossierGetMaatwerkDossier>>,
  TError = ErrorType<void>,
>(
  params?: MaybeRefOrGetter<MaatwerkdossierGetMaatwerkDossierParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof maatwerkdossierGetMaatwerkDossier>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMaatwerkdossierGetMaatwerkDossierQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Maatwerk.Aanvragen</li></ul>
 * @summary Maakt een nieuw maatwerkdossier aan voor het opgegeven offerteproduct.
 */
export const maatwerkdossierCreateMaatwerkDossier = (
  params?: MaybeRefOrGetter<MaatwerkdossierCreateMaatwerkDossierParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = toValue(params);

  return customInstance<Result1OfSUREbusinessCommonDomainTypedIdsMaatwerkdossierId>(
    { url: `/api/v1/maatwerk`, method: 'POST', params, signal },
    options,
  );
};

export const getMaatwerkdossierCreateMaatwerkDossierMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof maatwerkdossierCreateMaatwerkDossier>>,
    TError,
    MaatwerkdossierCreateMaatwerkDossierMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof maatwerkdossierCreateMaatwerkDossier>>,
  TError,
  MaatwerkdossierCreateMaatwerkDossierMutationVariables,
  TContext
> => {
  const mutationKey = ['maatwerkdossierCreateMaatwerkDossier'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof maatwerkdossierCreateMaatwerkDossier>>,
    MaatwerkdossierCreateMaatwerkDossierMutationVariables
  > = (props) => {
    const { params } = props ?? {};

    return maatwerkdossierCreateMaatwerkDossier(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MaatwerkdossierCreateMaatwerkDossierMutationResult = NonNullable<
  Awaited<ReturnType<typeof maatwerkdossierCreateMaatwerkDossier>>
>;

export type MaatwerkdossierCreateMaatwerkDossierMutationError = ErrorType<void>;
export type MaatwerkdossierCreateMaatwerkDossierMutationVariables = {
  params?: MaatwerkdossierCreateMaatwerkDossierParams;
};

/**
 * @summary Maakt een nieuw maatwerkdossier aan voor het opgegeven offerteproduct.
 */
export const useMaatwerkdossierCreateMaatwerkDossier = <
  TError = ErrorType<void>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof maatwerkdossierCreateMaatwerkDossier>>,
      TError,
      MaatwerkdossierCreateMaatwerkDossierMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof maatwerkdossierCreateMaatwerkDossier>>,
  TError,
  MaatwerkdossierCreateMaatwerkDossierMutationVariables,
  TContext
> => {
  return useMutation(getMaatwerkdossierCreateMaatwerkDossierMutationOptions(options), queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Maatwerk.Inzien</li></ul>
 * @summary Haal algemene details van een maatwerkdossier op.
 */
export const maatwerkdossierGetMaatwerkDossierDetails = (
  maatwerkdossierId: MaybeRefOrGetter<number | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  maatwerkdossierId = toValue(maatwerkdossierId);

  return customInstance<Result1OfAanvragenMaatwerkGetMaatwerkdossierDetailsDto>(
    { url: `/api/v1/maatwerk/${maatwerkdossierId}`, method: 'GET', signal },
    options,
  );
};

export const getMaatwerkdossierGetMaatwerkDossierDetailsQueryKey = (
  maatwerkdossierId: MaybeRefOrGetter<number | undefined | null>,
) => {
  return ['api', 'v1', 'maatwerk', maatwerkdossierId] as const;
};

export const getMaatwerkdossierGetMaatwerkDossierDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof maatwerkdossierGetMaatwerkDossierDetails>>,
  TError = ErrorType<void>,
>(
  maatwerkdossierId: MaybeRefOrGetter<number | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof maatwerkdossierGetMaatwerkDossierDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getMaatwerkdossierGetMaatwerkDossierDetailsQueryKey(maatwerkdossierId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof maatwerkdossierGetMaatwerkDossierDetails>>
  > = ({ signal }) =>
    maatwerkdossierGetMaatwerkDossierDetails(maatwerkdossierId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(
      () => toValue(maatwerkdossierId) !== null && toValue(maatwerkdossierId) !== undefined,
    ),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof maatwerkdossierGetMaatwerkDossierDetails>>,
    TError,
    TData
  >;
};

export type MaatwerkdossierGetMaatwerkDossierDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof maatwerkdossierGetMaatwerkDossierDetails>>
>;
export type MaatwerkdossierGetMaatwerkDossierDetailsQueryError = ErrorType<void>;

/**
 * @summary Haal algemene details van een maatwerkdossier op.
 */

export function useMaatwerkdossierGetMaatwerkDossierDetails<
  TData = Awaited<ReturnType<typeof maatwerkdossierGetMaatwerkDossierDetails>>,
  TError = ErrorType<void>,
>(
  maatwerkdossierId: MaybeRefOrGetter<number | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof maatwerkdossierGetMaatwerkDossierDetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMaatwerkdossierGetMaatwerkDossierDetailsQueryOptions(
    maatwerkdossierId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul></ul>
 * @summary Haal dekkingsspecificaties voor het offerte/aanvraagformulier op.
 */
export const maatwerkdossierGetOfferteformulierDekkingen = (
  offerteproductId: MaybeRefOrGetter<number | undefined | null>,
  productmaatschappijId: MaybeRefOrGetter<string | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  offerteproductId = toValue(offerteproductId);
  productmaatschappijId = toValue(productmaatschappijId);

  return customInstance<Result1OfAanvragenMaatwerkGetWagenparkSpecificatiesVoorOfferteformulierDto>(
    {
      url: `/api/v1/maatwerk/offerteproduct/${offerteproductId}/premiedetails/${productmaatschappijId}/offerteformulier-dekkingen`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getMaatwerkdossierGetOfferteformulierDekkingenQueryKey = (
  offerteproductId: MaybeRefOrGetter<number | undefined | null>,
  productmaatschappijId: MaybeRefOrGetter<string | undefined | null>,
) => {
  return [
    'api',
    'v1',
    'maatwerk',
    'offerteproduct',
    offerteproductId,
    'premiedetails',
    productmaatschappijId,
    'offerteformulier-dekkingen',
  ] as const;
};

export const getMaatwerkdossierGetOfferteformulierDekkingenQueryOptions = <
  TData = Awaited<ReturnType<typeof maatwerkdossierGetOfferteformulierDekkingen>>,
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
>(
  offerteproductId: MaybeRefOrGetter<number | undefined | null>,
  productmaatschappijId: MaybeRefOrGetter<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof maatwerkdossierGetOfferteformulierDekkingen>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getMaatwerkdossierGetOfferteformulierDekkingenQueryKey(
    offerteproductId,
    productmaatschappijId,
  );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof maatwerkdossierGetOfferteformulierDekkingen>>
  > = ({ signal }) =>
    maatwerkdossierGetOfferteformulierDekkingen(
      offerteproductId,
      productmaatschappijId,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: computed(
      () =>
        toValue(offerteproductId) !== null &&
        toValue(offerteproductId) !== undefined &&
        toValue(productmaatschappijId) !== null &&
        toValue(productmaatschappijId) !== undefined,
    ),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof maatwerkdossierGetOfferteformulierDekkingen>>,
    TError,
    TData
  >;
};

export type MaatwerkdossierGetOfferteformulierDekkingenQueryResult = NonNullable<
  Awaited<ReturnType<typeof maatwerkdossierGetOfferteformulierDekkingen>>
>;
export type MaatwerkdossierGetOfferteformulierDekkingenQueryError = ErrorType<
  void | MicrosoftAspNetCoreMvcProblemDetails | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
>;

/**
 * @summary Haal dekkingsspecificaties voor het offerte/aanvraagformulier op.
 */

export function useMaatwerkdossierGetOfferteformulierDekkingen<
  TData = Awaited<ReturnType<typeof maatwerkdossierGetOfferteformulierDekkingen>>,
  TError = ErrorType<
    | void
    | MicrosoftAspNetCoreMvcProblemDetails
    | MicrosoftAspNetCoreHttpHttpValidationProblemDetails
  >,
>(
  offerteproductId: MaybeRefOrGetter<number | undefined | null>,
  productmaatschappijId: MaybeRefOrGetter<string | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof maatwerkdossierGetOfferteformulierDekkingen>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMaatwerkdossierGetOfferteformulierDekkingenQueryOptions(
    offerteproductId,
    productmaatschappijId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Maatwerk.Aanvragen</li></ul>
 * @summary Haal selecteerbare maatschappijen van een maatwerkdossier op.
 */
export const maatwerkdossierGetSelecteerbareMaatschappijen = (
  maatwerkdossierId: MaybeRefOrGetter<number | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  maatwerkdossierId = toValue(maatwerkdossierId);

  return customInstance<CollectionResultOfProductenMaatschappijenGetSelecteerbareProductmaatschappijenVoorProductDto>(
    { url: `/api/v1/maatwerk/${maatwerkdossierId}/maatschappijen`, method: 'GET', signal },
    options,
  );
};

export const getMaatwerkdossierGetSelecteerbareMaatschappijenQueryKey = (
  maatwerkdossierId: MaybeRefOrGetter<number | undefined | null>,
) => {
  return ['api', 'v1', 'maatwerk', maatwerkdossierId, 'maatschappijen'] as const;
};

export const getMaatwerkdossierGetSelecteerbareMaatschappijenQueryOptions = <
  TData = Awaited<ReturnType<typeof maatwerkdossierGetSelecteerbareMaatschappijen>>,
  TError = ErrorType<void>,
>(
  maatwerkdossierId: MaybeRefOrGetter<number | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof maatwerkdossierGetSelecteerbareMaatschappijen>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getMaatwerkdossierGetSelecteerbareMaatschappijenQueryKey(maatwerkdossierId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof maatwerkdossierGetSelecteerbareMaatschappijen>>
  > = ({ signal }) =>
    maatwerkdossierGetSelecteerbareMaatschappijen(maatwerkdossierId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(
      () => toValue(maatwerkdossierId) !== null && toValue(maatwerkdossierId) !== undefined,
    ),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof maatwerkdossierGetSelecteerbareMaatschappijen>>,
    TError,
    TData
  >;
};

export type MaatwerkdossierGetSelecteerbareMaatschappijenQueryResult = NonNullable<
  Awaited<ReturnType<typeof maatwerkdossierGetSelecteerbareMaatschappijen>>
>;
export type MaatwerkdossierGetSelecteerbareMaatschappijenQueryError = ErrorType<void>;

/**
 * @summary Haal selecteerbare maatschappijen van een maatwerkdossier op.
 */

export function useMaatwerkdossierGetSelecteerbareMaatschappijen<
  TData = Awaited<ReturnType<typeof maatwerkdossierGetSelecteerbareMaatschappijen>>,
  TError = ErrorType<void>,
>(
  maatwerkdossierId: MaybeRefOrGetter<number | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof maatwerkdossierGetSelecteerbareMaatschappijen>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMaatwerkdossierGetSelecteerbareMaatschappijenQueryOptions(
    maatwerkdossierId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Maatwerk.Aanvragen</li></ul>
 * @summary Haal selecteerbare maatschappijen voor maatwerkdossier met check of premiedetails is aangemaakt.
 */
export const maatwerkdossierGetSelecteerbareMaatschappijenPremiedetails = (
  maatwerkdossierId: MaybeRefOrGetter<number | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  maatwerkdossierId = toValue(maatwerkdossierId);

  return customInstance<CollectionResultOfAanvragenMaatwerkGetPremiedetailsBijMaatschappijenVoorMaatwerkMaatschappijenPremiedetailsDto>(
    {
      url: `/api/v1/maatwerk/${maatwerkdossierId}/maatschappijen-premiedetails`,
      method: 'GET',
      signal,
    },
    options,
  );
};

export const getMaatwerkdossierGetSelecteerbareMaatschappijenPremiedetailsQueryKey = (
  maatwerkdossierId: MaybeRefOrGetter<number | undefined | null>,
) => {
  return ['api', 'v1', 'maatwerk', maatwerkdossierId, 'maatschappijen-premiedetails'] as const;
};

export const getMaatwerkdossierGetSelecteerbareMaatschappijenPremiedetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof maatwerkdossierGetSelecteerbareMaatschappijenPremiedetails>>,
  TError = ErrorType<void>,
>(
  maatwerkdossierId: MaybeRefOrGetter<number | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof maatwerkdossierGetSelecteerbareMaatschappijenPremiedetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    getMaatwerkdossierGetSelecteerbareMaatschappijenPremiedetailsQueryKey(maatwerkdossierId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof maatwerkdossierGetSelecteerbareMaatschappijenPremiedetails>>
  > = ({ signal }) =>
    maatwerkdossierGetSelecteerbareMaatschappijenPremiedetails(
      maatwerkdossierId,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: computed(
      () => toValue(maatwerkdossierId) !== null && toValue(maatwerkdossierId) !== undefined,
    ),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof maatwerkdossierGetSelecteerbareMaatschappijenPremiedetails>>,
    TError,
    TData
  >;
};

export type MaatwerkdossierGetSelecteerbareMaatschappijenPremiedetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof maatwerkdossierGetSelecteerbareMaatschappijenPremiedetails>>
>;
export type MaatwerkdossierGetSelecteerbareMaatschappijenPremiedetailsQueryError = ErrorType<void>;

/**
 * @summary Haal selecteerbare maatschappijen voor maatwerkdossier met check of premiedetails is aangemaakt.
 */

export function useMaatwerkdossierGetSelecteerbareMaatschappijenPremiedetails<
  TData = Awaited<ReturnType<typeof maatwerkdossierGetSelecteerbareMaatschappijenPremiedetails>>,
  TError = ErrorType<void>,
>(
  maatwerkdossierId: MaybeRefOrGetter<number | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof maatwerkdossierGetSelecteerbareMaatschappijenPremiedetails>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMaatwerkdossierGetSelecteerbareMaatschappijenPremiedetailsQueryOptions(
    maatwerkdossierId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Maatwerk.Aanvragen</li></ul>
 * @summary Koppelt antwoordenset aan een maatwerkdossier
 */
export const maatwerkdossierKoppelAntwoordenset = (
  maatwerkdossierId: MaybeRefOrGetter<number | undefined | null>,
  params?: MaybeRefOrGetter<MaatwerkdossierKoppelAntwoordensetParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  maatwerkdossierId = toValue(maatwerkdossierId);
  params = toValue(params);

  return customInstance<void>(
    {
      url: `/api/v1/maatwerk/${maatwerkdossierId}/koppel-antwoordenset`,
      method: 'PUT',
      params,
      signal,
    },
    options,
  );
};

export const getMaatwerkdossierKoppelAntwoordensetMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof maatwerkdossierKoppelAntwoordenset>>,
    TError,
    MaatwerkdossierKoppelAntwoordensetMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof maatwerkdossierKoppelAntwoordenset>>,
  TError,
  MaatwerkdossierKoppelAntwoordensetMutationVariables,
  TContext
> => {
  const mutationKey = ['maatwerkdossierKoppelAntwoordenset'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof maatwerkdossierKoppelAntwoordenset>>,
    MaatwerkdossierKoppelAntwoordensetMutationVariables
  > = (props) => {
    const { maatwerkdossierId, params } = props ?? {};

    return maatwerkdossierKoppelAntwoordenset(maatwerkdossierId, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MaatwerkdossierKoppelAntwoordensetMutationResult = NonNullable<
  Awaited<ReturnType<typeof maatwerkdossierKoppelAntwoordenset>>
>;

export type MaatwerkdossierKoppelAntwoordensetMutationError = ErrorType<void>;
export type MaatwerkdossierKoppelAntwoordensetMutationVariables = {
  maatwerkdossierId: number | undefined | null;
  params?: MaatwerkdossierKoppelAntwoordensetParams;
};

/**
 * @summary Koppelt antwoordenset aan een maatwerkdossier
 */
export const useMaatwerkdossierKoppelAntwoordenset = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof maatwerkdossierKoppelAntwoordenset>>,
      TError,
      MaatwerkdossierKoppelAntwoordensetMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof maatwerkdossierKoppelAntwoordenset>>,
  TError,
  MaatwerkdossierKoppelAntwoordensetMutationVariables,
  TContext
> => {
  return useMutation(getMaatwerkdossierKoppelAntwoordensetMutationOptions(options), queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Maatwerk.Aanvragen</li></ul>
 * @summary Koppelt antwoordenset aan een maatwerkdossier
 */
export const maatwerkdossierVerzoekIndienen = (
  maatwerkdossierId: MaybeRefOrGetter<number | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  maatwerkdossierId = toValue(maatwerkdossierId);

  return customInstance<void>(
    { url: `/api/v1/maatwerk/${maatwerkdossierId}/verzoek-indienen`, method: 'POST', signal },
    options,
  );
};

export const getMaatwerkdossierVerzoekIndienenMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof maatwerkdossierVerzoekIndienen>>,
    TError,
    MaatwerkdossierVerzoekIndienenMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof maatwerkdossierVerzoekIndienen>>,
  TError,
  MaatwerkdossierVerzoekIndienenMutationVariables,
  TContext
> => {
  const mutationKey = ['maatwerkdossierVerzoekIndienen'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof maatwerkdossierVerzoekIndienen>>,
    MaatwerkdossierVerzoekIndienenMutationVariables
  > = (props) => {
    const { maatwerkdossierId } = props ?? {};

    return maatwerkdossierVerzoekIndienen(maatwerkdossierId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MaatwerkdossierVerzoekIndienenMutationResult = NonNullable<
  Awaited<ReturnType<typeof maatwerkdossierVerzoekIndienen>>
>;

export type MaatwerkdossierVerzoekIndienenMutationError = ErrorType<void>;
export type MaatwerkdossierVerzoekIndienenMutationVariables = {
  maatwerkdossierId: number | undefined | null;
};

/**
 * @summary Koppelt antwoordenset aan een maatwerkdossier
 */
export const useMaatwerkdossierVerzoekIndienen = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof maatwerkdossierVerzoekIndienen>>,
      TError,
      MaatwerkdossierVerzoekIndienenMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof maatwerkdossierVerzoekIndienen>>,
  TError,
  MaatwerkdossierVerzoekIndienenMutationVariables,
  TContext
> => {
  return useMutation(getMaatwerkdossierVerzoekIndienenMutationOptions(options), queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Maatwerk.Annuleren</li></ul>
 * @summary Maatwerk annuleren
 */
export const maatwerkdossierAnnuleren = (
  maatwerkdossierId: MaybeRefOrGetter<number | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  maatwerkdossierId = toValue(maatwerkdossierId);

  return customInstance<void>(
    { url: `/api/v1/maatwerk/${maatwerkdossierId}/annuleren`, method: 'POST', signal },
    options,
  );
};

export const getMaatwerkdossierAnnulerenMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof maatwerkdossierAnnuleren>>,
    TError,
    MaatwerkdossierAnnulerenMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof maatwerkdossierAnnuleren>>,
  TError,
  MaatwerkdossierAnnulerenMutationVariables,
  TContext
> => {
  const mutationKey = ['maatwerkdossierAnnuleren'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof maatwerkdossierAnnuleren>>,
    MaatwerkdossierAnnulerenMutationVariables
  > = (props) => {
    const { maatwerkdossierId } = props ?? {};

    return maatwerkdossierAnnuleren(maatwerkdossierId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MaatwerkdossierAnnulerenMutationResult = NonNullable<
  Awaited<ReturnType<typeof maatwerkdossierAnnuleren>>
>;

export type MaatwerkdossierAnnulerenMutationError = ErrorType<void>;
export type MaatwerkdossierAnnulerenMutationVariables = {
  maatwerkdossierId: number | undefined | null;
};

/**
 * @summary Maatwerk annuleren
 */
export const useMaatwerkdossierAnnuleren = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof maatwerkdossierAnnuleren>>,
      TError,
      MaatwerkdossierAnnulerenMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof maatwerkdossierAnnuleren>>,
  TError,
  MaatwerkdossierAnnulerenMutationVariables,
  TContext
> => {
  return useMutation(getMaatwerkdossierAnnulerenMutationOptions(options), queryClient);
};
/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Maatwerk.Inzien</li></ul>
 * @summary Haal de aan een maatwerkdossier gekoppelde documenten op
 */
export const maatwerkdossierGetDocumenten = (
  maatwerkdossierId: MaybeRefOrGetter<number | undefined | null>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  maatwerkdossierId = toValue(maatwerkdossierId);

  return customInstance<CollectionResultOfDocumentenDocumentenGetMaatwerkDocumentenDto>(
    { url: `/api/v1/maatwerk/${maatwerkdossierId}/documenten`, method: 'GET', signal },
    options,
  );
};

export const getMaatwerkdossierGetDocumentenQueryKey = (
  maatwerkdossierId: MaybeRefOrGetter<number | undefined | null>,
) => {
  return ['api', 'v1', 'maatwerk', maatwerkdossierId, 'documenten'] as const;
};

export const getMaatwerkdossierGetDocumentenQueryOptions = <
  TData = Awaited<ReturnType<typeof maatwerkdossierGetDocumenten>>,
  TError = ErrorType<void>,
>(
  maatwerkdossierId: MaybeRefOrGetter<number | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof maatwerkdossierGetDocumenten>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getMaatwerkdossierGetDocumentenQueryKey(maatwerkdossierId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof maatwerkdossierGetDocumenten>>> = ({
    signal,
  }) => maatwerkdossierGetDocumenten(maatwerkdossierId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(
      () => toValue(maatwerkdossierId) !== null && toValue(maatwerkdossierId) !== undefined,
    ),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof maatwerkdossierGetDocumenten>>, TError, TData>;
};

export type MaatwerkdossierGetDocumentenQueryResult = NonNullable<
  Awaited<ReturnType<typeof maatwerkdossierGetDocumenten>>
>;
export type MaatwerkdossierGetDocumentenQueryError = ErrorType<void>;

/**
 * @summary Haal de aan een maatwerkdossier gekoppelde documenten op
 */

export function useMaatwerkdossierGetDocumenten<
  TData = Awaited<ReturnType<typeof maatwerkdossierGetDocumenten>>,
  TError = ErrorType<void>,
>(
  maatwerkdossierId: MaybeRefOrGetter<number | undefined | null>,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof maatwerkdossierGetDocumenten>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getMaatwerkdossierGetDocumentenQueryOptions(maatwerkdossierId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 *  <br /> Required permissions:<br /> <ul> <li>Permission: Maatwerk.BestandenToevoegen</li></ul>
 * @summary Document uploaden bij een maatwerkdossier
 */
export const maatwerkdossierDocumentUploaden = (
  maatwerkdossierId: MaybeRefOrGetter<number | undefined | null>,
  maatwerkdossierDocumentUploadenBody?: MaybeRefOrGetter<MaatwerkdossierDocumentUploadenBody>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  maatwerkdossierId = toValue(maatwerkdossierId);
  maatwerkdossierDocumentUploadenBody = toValue(maatwerkdossierDocumentUploadenBody);
  const formData = new FormData();
  if (maatwerkdossierDocumentUploadenBody?.['Dto.Bestandsnaam'] !== undefined) {
    formData.append(`Dto.Bestandsnaam`, maatwerkdossierDocumentUploadenBody['Dto.Bestandsnaam']);
  }
  if (maatwerkdossierDocumentUploadenBody?.['Dto.DocumentType'] !== undefined) {
    formData.append(`Dto.DocumentType`, maatwerkdossierDocumentUploadenBody['Dto.DocumentType']);
  }
  if (maatwerkdossierDocumentUploadenBody?.['Dto.AfkomstigePartij'] !== undefined) {
    formData.append(
      `Dto.AfkomstigePartij`,
      maatwerkdossierDocumentUploadenBody['Dto.AfkomstigePartij'],
    );
  }
  if (maatwerkdossierDocumentUploadenBody?.['Dto.Toelichting'] !== undefined) {
    formData.append(`Dto.Toelichting`, maatwerkdossierDocumentUploadenBody['Dto.Toelichting']);
  }
  if (maatwerkdossierDocumentUploadenBody?.['Dto.IsGeheim'] !== undefined) {
    formData.append(`Dto.IsGeheim`, maatwerkdossierDocumentUploadenBody['Dto.IsGeheim'].toString());
  }
  if (maatwerkdossierDocumentUploadenBody?.File !== undefined) {
    formData.append(`File`, maatwerkdossierDocumentUploadenBody.File);
  }

  return customInstance<void>(
    {
      url: `/api/v1/maatwerk/${maatwerkdossierId}/documenten`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal,
    },
    options,
  );
};

export const getMaatwerkdossierDocumentUploadenMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof maatwerkdossierDocumentUploaden>>,
    TError,
    MaatwerkdossierDocumentUploadenMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof maatwerkdossierDocumentUploaden>>,
  TError,
  MaatwerkdossierDocumentUploadenMutationVariables,
  TContext
> => {
  const mutationKey = ['maatwerkdossierDocumentUploaden'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof maatwerkdossierDocumentUploaden>>,
    MaatwerkdossierDocumentUploadenMutationVariables
  > = (props) => {
    const { maatwerkdossierId, data } = props ?? {};

    return maatwerkdossierDocumentUploaden(maatwerkdossierId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MaatwerkdossierDocumentUploadenMutationResult = NonNullable<
  Awaited<ReturnType<typeof maatwerkdossierDocumentUploaden>>
>;
export type MaatwerkdossierDocumentUploadenMutationBody =
  | MaatwerkdossierDocumentUploadenBody
  | undefined;
export type MaatwerkdossierDocumentUploadenMutationError = ErrorType<void>;
export type MaatwerkdossierDocumentUploadenMutationVariables = {
  maatwerkdossierId: number | undefined | null;
  data?: MaatwerkdossierDocumentUploadenBody;
};

/**
 * @summary Document uploaden bij een maatwerkdossier
 */
export const useMaatwerkdossierDocumentUploaden = <TError = ErrorType<void>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof maatwerkdossierDocumentUploaden>>,
      TError,
      MaatwerkdossierDocumentUploadenMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof maatwerkdossierDocumentUploaden>>,
  TError,
  MaatwerkdossierDocumentUploadenMutationVariables,
  TContext
> => {
  return useMutation(getMaatwerkdossierDocumentUploadenMutationOptions(options), queryClient);
};
